/*
  Реестры волн на конвейере: страницы режет сервер (23.10.2026, находка проверки).

  До этого дня `GET /conveyor/registries` отдавал двадцать последних реестров списком, а
  `DocumentList` резал их на страницы в браузере: двадцать первый реестр не показывался нигде -
  ровно та беда, ради которой список и заводили (09.09.2026: «реестр сформирован, а его не
  видно»). Теперь список читается окнами (`limit`, `offset`), как документы на карточке счёта
  (`AccountDocuments.jsx`), и `DocumentList` только рисует страницу.

  `version` - та же версия, что у очереди: после «Собрать реестр» или удаления реестра она
  растёт, и текущая страница перечитывается - собранный реестр виден сразу.
*/

import { useCallback } from 'react'

import { api } from '../api/client.js'
import { Loading, Notice } from './Common.jsx'
import DocumentList from './DocumentList.jsx'
import usePagedList from './usePagedList.js'

const TITLE = 'Реестры волн'

export default function WaveRegistries({ version, onDeleted }) {
  const load = useCallback((window) => api.waveRegistries(window), [])
  const { rows, error, bar } = usePagedList(load, undefined, version)

  if (error) {
    return (
      <section className="section">
        <h2 className="section__title">{TITLE}</h2>
        <Notice error={error} />
      </section>
    )
  }
  if (rows === null) return <Loading what="Загружаем реестры волн" />

  return (
    <DocumentList
      documents={rows}
      paging={bar}
      title={TITLE}
      emptyTitle="Реестров пока нет"
      // Реестр, собранный не на тот участок, - обычная ошибка дня подачи, и
      // оставлять его рядом с верным опасно: юрист несёт в суд бумагу,
      // выбранную из двух похожих.
      onDeleted={onDeleted}
      empty={
        <>
          Реестр появляется здесь после того, как вы отметите счета в очереди и нажмёте «Собрать
          реестр». С ним юрист идёт на участок: по нему потом сверяют, что ушло и что вернулось.
        </>
      }
    />
  )
}
